const PrizeLandingPage = ({ children }) => {
  return (
    <div className='pageContainer'>
      {children}

      <style jsx>
        {`
          .pageContainer {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
          }
          
          :global(.pageContainer .hero) {
            width: 100%;
            max-height: 470px;
            object-fit: cover;
          }
          
          :global(.pageContainer .pageTitleGreenSectionContainer) {
            max-width: 500px;
          }
          
          :global(.pageContainer .pageTitle) {
            max-width: 600px;
            width: 100%;
            line-height: 1.1;
            font-size: 2.3em;
          }
          
          @media(max-width: 500px) {
            :global(.pageContainer .pageTitle) {
              font-size: 1.3em;
              max-width: 400px;
            }
          }
          
          :global(.pageContainer p), :global(.pageContainer li) {
            font-size: 1.1rem;
          }
        `}
      </style>
    </div>
  );
};

export default PrizeLandingPage;